import ChevronUpSVG from "@design-system/ui-icons/vanilla/ChevronUp"
import { createIcon } from "../createIcon"

export const ChevronUpIcon = createIcon(ChevronUpSVG)
